// Build information, automatically generated by `ng-info`
const build = {
    version: "1.02.00",
    timestamp: "Wed Jul 03 2024 08:43:05 GMT+0000 (Coordinated Universal Time)",
    message: null,
    git: {
        user: null,
        branch: "develop",
        hash: "99e623",
        fullHash: "99e623425889da71e5e600f7e2ceb0e23d04a0f5"
    }
};

export default build;